import {IToken} from "@/module/user";
import {LocalStorage} from "@/app";

export default {
    setAccessToken({commit}: { commit: any }, value: IToken): void
    {
        commit("setAccessToken", value);
    },
    setEnv({commit}: { commit: any }, env: string): void
    {
        LocalStorage.setItem("env", env);
        commit("setEnv", env);
    },
    setEnvType({commit}: { commit: any }, envType: string): void
    {
        LocalStorage.setItem("envType", envType);
        commit("setEnvType", envType);
    },
    setEnvBrand({commit}: { commit: any }, envBrand: string): void
    {
        LocalStorage.setItem("envBrand", envBrand);
    },
    setFinancedSubjectType({commit}: { commit: any }, financedSubjectType: string): void
    {
        LocalStorage.setItem("financedSubjectType", financedSubjectType);
        commit("setFinancedSubjectType", financedSubjectType);
    },
    setClientType({commit}: { commit: any }, clientType: string): void
    {
        LocalStorage.setItem("clientType", clientType);
        commit("setClientType", clientType);
    },
    setOrderType({commit}: { commit: any }, orderType: string): void
    {
        LocalStorage.setItem("orderType", orderType);
        commit("setOrderType", orderType);
    },
    setFinancingType({commit}: { commit: any }, financingType: string): void
    {
        LocalStorage.setItem("financingType", financingType);
        commit("setFinancingType", financingType);
    },
    setCashFinancingType({commit}: { commit: any }, cashFinancingType: string): void
    {
        LocalStorage.setItem("cashFinancingType", cashFinancingType);
        commit("setCashFinancingType", cashFinancingType);
    },
    setShowQrCode({commit}: { commit: any }, showQrCode: boolean): void
    {
        LocalStorage.setItem("showQrCode", String(showQrCode));
        commit("setShowQrCode", showQrCode);
    },
    setCopyToClipboard({commit}: { commit: any }, copyToClipboard: boolean): void
    {
        LocalStorage.setItem("copyToClipboard", String(copyToClipboard));
        commit("setCopyToClipboard", copyToClipboard);
    },
    setWalletWithOrder({commit}: { commit: any }, walletWithOrder: string): void
    {
        LocalStorage.setItem("walletWithOrder", walletWithOrder);
        commit("setWalletWithOrder", walletWithOrder);
    },
};
